import { Component, computed, inject } from '@angular/core';
import { SettingsStoreService } from '@core/services';
import { SharedModule } from '@shared/shared.module';
import { timezoneOffset } from '@shared/utils/timezone.util';
import { pageUrls } from 'src/app/configuration/pages';

/**
 * View-only header indicator for the timezone used to display data. Clicking it opens the
 * Preferences tab of the user profile, where the timezone can be changed.
 */
@Component({
  selector: 'app-timezone-indicator',
  imports: [SharedModule],
  templateUrl: './timezone-indicator.component.html',
})
export class TimezoneIndicatorComponent {
  private readonly settings = inject(SettingsStoreService);

  readonly profileUrl = pageUrls.profile;
  readonly timezone = this.settings.timezone;
  readonly offset = computed(() => timezoneOffset(this.settings.timezone()));
}
